module.exports = __webpack_public_path__ + "media/images/shelf_preview_landscape-594c535ef16a759f8a0a32c8e495d1c5.png";